import ACTIONS from "../actions/types";

function reviewAdminReducer(state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_PAGE_IDS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}

export default reviewAdminReducer;
